import * as React from 'react';
const IconTick = ({ color = '#020000' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={16}
    style={{ width: '20px', height: '16px' }}
    viewBox="0 0 20 16"
    fill="none"
  >
    <path
      d="M7.23792 16C6.58389 16 5.9577 15.7338 5.49385 15.2585L0.67909 10.2917C-0.257886 9.28885 -0.220778 7.69662 0.762583 6.73653C1.71811 5.80495 3.22098 5.80971 4.16724 6.75079L7.21009 9.89248L15.7774 0.771594C16.719 -0.231275 18.2729 -0.259793 19.247 0.705053C20.2257 1.6699 20.2535 3.25738 19.3119 4.26025L9.00055 15.23C8.54134 15.7196 7.9105 15.9952 7.2472 16H7.23328H7.23792Z"
      fill={color}
    />
  </svg>
);
export default IconTick;
